export const ruleConfig = {
    lowerLastRound: [{ required: true, message: '该输入框不能为空', trigger: ['blur'] }],
    quoteType: [{ required: true, message: '该输入框不能为空', trigger: ['blur'] }],
    changeBidMin: [{ required: true, message: '请输入最小出价变化量', trigger: ['blur'] }],
    quotePrecision: [{ required: true, message: '请输入预警时间（分）', trigger: ['blur'] }],
    minimumDecline: [{ required: true, message: '报价最低降幅', trigger: ['blur'] }],
    prewarningTime: [{ required: true, message: '请输入报价小位数', trigger: ['blur'] }],
    rankVisible: [{ required: true, message: '请输入自身排名是否可见', trigger: ['blur'] }],
    lowestQuoteVisible: [{ required: true, message: '请输入最低价是否可见', trigger: ['blur'] }],
    blockPriceControl: [{ required: true, message: '请输入是否控制拦标价', trigger: ['blur'] }]
};

export const effectDateFrom = (rule, value, callback) => {
    const date = new Date(value);// 获取时间戳
    const time = date.getTime();
    var timestamp = new Date().getTime();// 获取的当前时间
    if (!value) {
        callback(new Error('请输入洽谈开始时间'));
    } else if (timestamp - time >= 0) {
        callback(new Error('不能小于当前时间'));
    } else { callback(); }
};

export const countTimeSet = (time) => {
    const hour = Math.floor(time / 60 / 60) < 10 ? '0' + Math.floor(time / 60 / 60) : Math.floor(time / 60 / 60);
    const minutes = Math.floor(time / 60 % 60) < 10 ? '0' + Math.floor(time / 60 % 60) : Math.floor(time / 60 % 60);
    const seconds = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
    return hour + ':' + minutes + ':' + seconds;
};

export const timeStr = (date) => {
    const time = date.getTime();
    const timestamp = new Date().getTime(); // 获取的当前时间
    const num = ((time - timestamp) / 1000);
    const d = Math.floor(num / 60 / 60 / 24);
    const h = Math.floor(num / 60 / 60 % 24);
    const m = Math.floor(num / 60 % 60);
    const s = Math.floor(num % 60);
    return {
        time: time,
        timestamp: timestamp,
        timestr: `${h + d * 24}小时${m}分${s}秒`
    };
};
export const parFn = (custom, selectedRow, loginState) => {
    const params = {};
    params.customerName = custom.customerName;
    params.customerCode = custom.customerCode;
    params.businessType = loginState.businessType;
    params.lineList = [];
    selectedRow.forEach(item => {
        if (item.children === null && item.lineCode !== null) {
            params.lineList.push({
                lineCode: item.lineCode,
                lineName: item.lineName,
                startProvinceCode: item.esstFromProvinceCode,
                startProvinceName: item.esstFromProvinceName,
                startCityCode: item.esstFromCityCode,
                startCityName: item.esstFromCityName,
                startDistrictCode: item.esstFromDistrictCode,
                startDistrictName: item.esstFromDistrictName,
                targetProvinceCode: item.esstToProvinceCode,
                targetProvinceName: item.esstToProvinceName,
                targetCityCode: item.esstToCityCode,
                targetCityName: item.esstToCityName,
                targetDistrictCode: item.esstToDistrictCode,
                targetDistrictName: item.esstToDistrictName
            });
        }
    });
    return params;
};
export const formatData = (data, dictData) => {
    data.map(item => {
        item.tenderStatus_ = dictData.BID_SU_TENDER_STATUS[item.tenderStatus];
        item.quoteType_ = dictData.BID_SU_TENDER_TYPE[item.quoteType];
        item.shortlist = dictData.BID_WON_STATUS[item.shortlist];
        item.blockPriceControl = (!item.blockPriceControl && item.blockPriceControl === 'N') || item.blockPriceControl;
    });
    return data;
};
